import { create } from '@bufbuild/protobuf';
import { type Note, type NoteChange, NoteChangeSchema, NoteKind, Role } from '@/gen/tagn/v1/notes_pb';
import type { LocalNote, NoteKind as LocalKind, Role as LocalRole } from '@/domain/note';

export function kindFromProto(k: NoteKind): LocalKind {
  return k === NoteKind.TODO ? 'todo' : 'text';
}

export function kindToProto(k: LocalKind): NoteKind {
  return k === 'todo' ? NoteKind.TODO : NoteKind.TEXT;
}

export function roleFromProto(r: Role): LocalRole {
  switch (r) {
    case Role.EDITOR:
      return 'editor';
    case Role.VIEWER:
      return 'viewer';
    default:
      return 'owner';
  }
}

export function roleToProto(r: LocalRole): Role {
  return { owner: Role.OWNER, editor: Role.EDITOR, viewer: Role.VIEWER }[r];
}

/** Converts a server note into a clean (non dirty) local note. */
export function noteFromProto(n: Note, localRev = 0): LocalNote {
  return {
    id: n.id,
    kind: kindFromProto(n.kind),
    title: n.title,
    content: n.content,
    tags: [...n.tags],
    pinned: n.pinned,
    archived: n.archived,
    deleted: n.deleted,
    version: Number(n.version),
    createdAt: Number(n.createdAtMs),
    updatedAt: Number(n.updatedAtMs),
    ownerId: n.ownerId,
    role: roleFromProto(n.role),
    shared: n.shared,
    dirty: 0,
    localRev,
  };
}

export function changeFromLocal(n: LocalNote): NoteChange {
  return create(NoteChangeSchema, {
    id: n.id,
    kind: kindToProto(n.kind),
    title: n.title,
    content: n.content,
    pinned: n.pinned,
    archived: n.archived,
    deleted: n.deleted,
    baseVersion: BigInt(n.version),
    updatedAtMs: BigInt(n.updatedAt),
  });
}
